import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  list: { data: [], loading: false },
  detail: { data: null, loading: false },
  options: { data: [], selected: [], loading: false },
  mounts: { data: [], selected: [], loading: false },
  props: { data: [], loading: false },
  mountOptions: { data: [], selected: [], loading: false },
  confirm: { title: '', content: '', visible: false, loading: false },
  saveLoading: false,
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
